module.exports = __webpack_public_path__ + "img/2_m.08761d22.jpg";